import AllQuickFilter from "./all-quick-filter";
import CarrierErrorQuickFilter from "./carrier-error-quick-filter";
import ShippingTooLongQuickFilter from "./shipping-to-long-quick-filter";
import ToBeTreatedQuickFilter from "./to-be-treated-quick-filter";
import ToValidateQuickFilter from "./to-validate-quick-filter";
import MarketplaceQuickFilter from "./marketplace-quick-filter.tsx";
import { useShopFlag } from "@/hooks/use-flag.ts";

export function QuickFiltersBar() {
  const isMarketplaceQuickFilterEnabled = useShopFlag(
    "isMarketplaceQuickFilterEnabled",
  );
  return (
    <div className="flex gap-4 overflow-auto w-full flex-wrap">
      <AllQuickFilter />
      <ToBeTreatedQuickFilter />
      {isMarketplaceQuickFilterEnabled && <MarketplaceQuickFilter />}
      <ToValidateQuickFilter />
      <ShippingTooLongQuickFilter />
      <CarrierErrorQuickFilter />
      {/* Add more quick filters as needed */}
    </div>
  );
}
